import { WidgetProps } from '@rjsf/core';
import { UnitSelector } from '../BaseComponents';

const UnitSelectorWidget = (props: WidgetProps) => {
    const { label, schema, value, onChange } = props;

    return (
        <div className="inches-input">
            <label>{label}</label>
            <UnitSelector
                value={value}
                defaultValue={schema.default as string}
                onChange={onChange}
            />
        </div>
    );
};

export default UnitSelectorWidget;
